// 매도 이력 API (tb_sell_history)
import axiosInstance from './axiosInstance';

// 매도 이력 목록 조회 (필터: account_name, ticker)
export const fetchSellList = async (params = {}) => {
  const response = await axiosInstance.get('/sell', { params });
  return response.data.data;
};

// 매도 저장 (등록/수정 통합 — sell_id 있으면 UPDATE, 없으면 INSERT)
export const saveSell = async (payload) => {
  const response = await axiosInstance.post('/sell/save', payload);
  return response.data;
};

// 매도 등록 (buy_id 필수)
export const createSell = async (payload) => {
  const response = await axiosInstance.post('/sell', payload);
  return response.data;
};

// 매도 수정
export const updateSell = async (id, payload) => {
  const response = await axiosInstance.put(`/sell/${id}`, payload);
  return response.data;
};

// 매도 삭제 (buy_history.is_sold 자동 롤백)
export const deleteSell = async (id) => {
  const response = await axiosInstance.delete(`/sell/${id}`);
  return response.data;
};

// 매수+매도 통합 조회
export const fetchCombinedList = async (params = {}) => {
  const response = await axiosInstance.get('/sell/combined', { params });
  return response.data.data;
};

// 합계 조회 (미매도 매수금액, 미매도 예상손익, 매도확정손익)
export const fetchSummary = async (params = {}) => {
  const response = await axiosInstance.get('/sell/summary', { params });
  return response.data;
};
